import React from 'react';

type Props = {
  loading?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
};

const SubmitButton: React.FC<Props> = ({ loading = false, disabled = false, children, onClick, type = 'submit' }) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
      className="w-full min-h-14 bg-[#0e444e] hover:bg-[#083338] text-white text-base sm:text-lg font-bold rounded-2xl shadow-lg hover:shadow-[#0e444e]/30 transform hover:-translate-y-0.5 active:translate-y-0 transition-all duration-300 flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none disabled:shadow-none group focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-[#d5b481]"
    >
      {loading ? (
        <>
          <svg className="animate-spin w-6 h-6 text-[#d5b481]" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <span role="status" aria-live="polite" className="text-[#d5b481]">در حال ارسال...</span>
        </>
      ) : (
        <>
          <span>{children}</span>
          <div className="w-8 h-8 rounded-xl bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors">
            <svg className="w-5 h-5 transform rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
            </svg>
          </div>
        </>
      )}
    </button>
  );
};

export default SubmitButton;
